import { timestampDate } from '@bufbuild/protobuf/wkt'
import { GridColDef } from '@mui/x-data-grid'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ProjectDto } from '@/generated/Messages/Basic_pb'

export const useUserDetailsProjectColumns = (): GridColDef<ProjectDto>[] => {
    const { t } = useTranslation()

    return useMemo(
        () => [
            {
                field: 'name',
                headerName: t('projects.name'),
                flex: 1,
                filterable: false,
                hideable: false,
                resizable: false,
            },
            {
                field: 'description',
                headerName: t('projects.description'),
                flex: 1,
                filterable: false,
                hideable: false,
                resizable: false,
            },
            {
                field: 'startAt',
                headerName: t('projects.startDate'),
                flex: 0.5,
                valueGetter: (_, row) =>
                    row.startAt ?
                        t('common.dateOnly.short', {
                            value: timestampDate(row.startAt),
                        })
                    :   '',
                filterable: false,
                hideable: false,
                resizable: false,
            },
            {
                field: 'endAt',
                headerName: t('projects.endDate'),
                flex: 0.5,
                valueGetter: (_, row) =>
                    row.endAt ?
                        t('common.dateOnly.short', {
                            value: timestampDate(row.endAt),
                        })
                    :   '',
                filterable: false,
                hideable: false,
                resizable: false,
            },
            {
                field: 'deletedAt',
                headerName: t('common.active'),
                flex: 0.5,
                valueGetter: (_, row) => !row.timestamps?.deletedAt,
                sortable: false,
                hideable: false,
                resizable: false,
                type: 'boolean',
                filterable: true,
            },
        ],
        [t]
    )
}
